

export default (function (value) {
  return function () {
    return value;
  };
});